module.exports = __webpack_public_path__ + "static/bbq-ca9be5b419a94c44b34c36a9100cf587.jpg";